// @ts-nocheck
import React, { FC, useState } from 'react';
import { confirmPasswordReset, verifyPasswordResetCode } from "firebase/auth";
import { whichAuth as getAuth } from '../../getAuth';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { showChangePasswordState } from '../../atoms';
import {
  IonButton,
  IonInput,
  IonItem,
  IonList,
  IonModal,
  IonSpinner,
  IonCardContent,
  IonCardHeader,
  IonContent,
  IonLabel,
  IonText
} from '@ionic/react';
import AlertModal from "../AlertModal";

const ChangePassword: FC = () => {
  
  const show = useRecoilValue(showChangePasswordState);
  const setShow = useSetRecoilState(showChangePasswordState);
  
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [modalMessage, setModalMessage] = useState<string>('');
  const [modalTitle, setModalTitle] = useState<string>('');

  const oobCode = new URLSearchParams(window.location.search).get('oobCode');
  
  const [inProgress, setInProgress] = useState<boolean>(false);
  
  const changePassword = () => {
    setInProgress(true);
    verifyPasswordResetCode(getAuth(), oobCode)
      .then(email => {
        confirmPasswordReset(getAuth(), oobCode, password)
          .then(() => {
            setShowConfirmation(true)
            setIsOpenModal(true)
            setModalTitle('Password changed')
            setModalMessage('Please log in using your new password.')
          });
      })
      .catch(() => {
        setIsOpenModal(true)
        setModalTitle('Failed to change your password')
      })
      .finally(() => setInProgress(false));
  }
  
  return (
    <IonModal isOpen={show}>
      <IonContent fullscreen>
      <IonCardContent className="h-full card-authentication">
        <IonCardContent className="right-authentication">
          <IonList lines="none" className="right-list-authentication">
            <IonCardHeader className="logo-authentication" />
            <IonLabel className="label-authentication">New password</IonLabel>
            <IonItem fill="outline" className="no-padding">
              <IonInput onIonChange={event => setPassword(event.detail.value)}
                className="input-authentication"
                type="password" />
            </IonItem>
            <IonLabel className="label-authentication">Confirm new password
            </IonLabel>
            <IonItem fill="outline" className="no-padding">
              <IonInput onIonChange={event => setConfirmPassword(event.detail.value)}
                className="input-authentication"
                type="password"/><br/>
            </IonItem>
            <IonItem className="no-padding">
             <IonButton disabled={!password || password !== confirmPassword}
                onClick={changePassword}
                className="button-authentication">
                { inProgress && <IonSpinner name="dots" /> }
                Change password
              </IonButton>
            </IonItem>
            {password.length !== 0 && (password !== confirmPassword) && 
              <IonText color="warning">Passwords do not match</IonText> }
          </IonList>
        </IonCardContent>
      </IonCardContent>
      <AlertModal
        isOpen={isOpenModal}
        title={modalTitle}
        subTitle={modalMessage}
        onClosed={() => {
          setIsOpenModal(false)
          if (showConfirmation) {
            setShowConfirmation(false)
            setShow(false)
          }
        }}
        textButton="Update"
      />
      </IonContent>
    </IonModal>
);}

export default ChangePassword;
